import {ethers, JsonRpcProvider} from "ethers";
import {useCallback, useEffect, useState} from "react";
import {NETWORKS_INFO, SupportedChainId} from "../../config/chains";

type ReturnData = {
  provider: JsonRpcProvider | null
  initProviderPending: boolean
}

export const useProvider = (): ReturnData => {
  const [provider, setProvider] = useState<JsonRpcProvider | null>(null)
  const [initProviderPending, setInitProviderPending] = useState<boolean>(true)
  const activeChain =
    process.env.REACT_APP_CHAIN_ENV === "mainnet"
      ? NETWORKS_INFO[SupportedChainId.ETHEREUM]
      : NETWORKS_INFO[SupportedChainId.SEPOLIA_ETHEREUM];

  const initProvider = useCallback(async (rpcUrlsIndex = 0) => {
    try {
      const provider = new ethers.JsonRpcProvider(activeChain.rpcUrls[rpcUrlsIndex])

      //rpc health check
      await provider.getBlockNumber()

      setProvider(provider)
      setInitProviderPending(false)
    } catch (error) {
      if (rpcUrlsIndex + 1 < activeChain.rpcUrls.length) {
        await initProvider(rpcUrlsIndex + 1)
      }

      if (rpcUrlsIndex + 1 === activeChain.rpcUrls.length) {
        setInitProviderPending(false)
      }
    }
  }, [activeChain.rpcUrls])

  useEffect(() => {
    (async () => {
      await initProvider()
    })()
  }, [initProvider])

  return { provider, initProviderPending }
}
